import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuSection } from "./MenuSection";
import {
  getCategories,
  getIsProductsLoading,
  getProducts,
} from "../redux/selectors";
import {
  fetchCategories,
  fetchProducts,
} from "../redux/productsData/operations";
import { reorganizeData } from "../data/helpers";
import { RadarLoader } from "./RadarLoader";
import { storeId } from "../data/constants";

export const Products = ({ page = "main" }) => {
  const dispatch = useDispatch();
  const productsData = useSelector(getProducts);
  const categoriesData = useSelector(getCategories);
  const sortedCategories = [...categoriesData].sort(
    (a, b) => a.order - b.order
  );
  const isProductsLoading = useSelector(getIsProductsLoading);

  const isDataLoading =
    isProductsLoading ||
    productsData.length === 0 ||
    categoriesData.length === 0;

  useEffect(() => {
    if (categoriesData.length === 0) {
      dispatch(fetchCategories());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (productsData.length === 0) {
      dispatch(fetchProducts(storeId || ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(fetchProducts(storeId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId]);

  const mainProducts = productsData
    .map((product) => {
      const { fr, ...variants } = product.variants || {};
      return { ...product, variants };
    })
    .filter((p) => Object.keys(p.variants).length > 0);

  const fundraisingProducts = productsData
    .filter((p) => p?.variants?.fr)
    .map((p) => ({ ...p, variants: { fr: p.variants.fr } }));

  const source = page === "fr" ? fundraisingProducts : mainProducts;

  const productsNew = productsData.length
    ? reorganizeData(source, sortedCategories)
    : [];

  if (isDataLoading) {
    return <RadarLoader />;
  }

  return (
    <div className="relative">
      {productsNew.map((el) => (
        <MenuSection data={el} key={el.categoryId} page={page} />
      ))}
    </div>
  );
};
